<template>
  <div class="baseForm">
    <div class="formDom">
      <Form ref="familyForm" :dataSource="getBaseForm" id="familyForm">
        <template v-slot:address>
          <a-alert
            v-show="checkDisplay('increasePeople')"
            style="margin:5px 0 0 10px"
            message="请填详细地址，如XX区XX街道XX小区1001"
            type="warning"
            show-icon
          />
        </template>
        <template v-slot:area>
          <span
            v-show="checkDisplay('increasePeople')"
            style="display: inline-block;line-height:34px;margin-left:5px;"
          >㎡</span>
        </template>
        <template v-slot:familyPerson>
          <div class="button">
            <a-button type="primary" @click="increasePeople" v-show="checkDisplay('increasePeople')">新增成员</a-button>
          </div>
          <div class="table" style="margin-top:10px;">
            <div class="personList">
              <a-table
                :columns="checkDisplay('increasePeople') ? columns : column"
                :data-source="peopleList"
                :pagination="false"
                :rowKey="(record) => record.id"
              >
                <span slot="action" slot-scope="text, data">
                  <!--                  <a @click="editPeople(data)">编辑</a>-->
                  <!--                  <a-divider type="vertical" />-->
                  <a @click="deletePeople(data)">删除</a>
                </span>
              </a-table>
            </div>
          </div>
        </template>
        <!--        帮扶项目-->
        <!--        <template v-slot:itemRelated>-->
        <!--          <div class="table" style="margin-top:10px;">-->
        <!--            <div class="personList">-->
        <!--              <a-table-->
        <!--                :columns="itemColumns"-->
        <!--                :data-source="initData.projectRelate || []"-->
        <!--                :pagination="false"-->
        <!--                :rowKey="(record)=>{record.process_base_id}"-->
        <!--              >-->
        <!--                <span slot="num" slot-scope="text,data,index">{{ index+1 }}</span>-->
        <!--                <span slot="action" slot-scope="text,data">-->
        <!--                  <a @click="show(data)">查看</a>-->
        <!--                </span>-->
        <!--              </a-table>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </template>-->
        <!--        <template v-slot:assitLog>-->
        <!--          <div class="table" style="margin-top:10px;">-->
        <!--            <div class="personList">-->
        <!--              <a-table-->
        <!--                :columns="logColumns"-->
        <!--                :data-source="initData.assitLog || []"-->
        <!--                :pagination="false"-->
        <!--                :rowKey="(record)=>{record.process_base_id}"-->
        <!--              >-->
        <!--                <span slot="num" slot-scope="text,data,index">{{ index+1 }}</span>-->
        <!--                <span slot="action" slot-scope="text,data">-->
        <!--                  <a @click="show(data)">查看</a>-->
        <!--                </span>-->
        <!--              </a-table>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </template>-->
      </Form>
    </div>
    <div class="modal">
      <a-modal title="新增家庭成员" :visible="visible" @cancel="cancel" @ok="handleOk">
        <div class="familyPeople">
          <Form ref="familyPeople" :dataSource="getFamilyForm" id="familyPeople"></Form>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import Form from '@/components/GlobalForm'
import { forms } from './formData'
import { getAgeAndSexByIDNum } from '@/utils/util'
import { checkIdCard } from '@/utils/checkFun'

const columns = [
  {
    title: '成员姓名',
    dataIndex: 'need_help_person_family_name',
    key: 'need_help_person_family_name'
  },
  {
    title: '与户主关系',
    dataIndex: 'need_help_person_family_relation',
    key: 'need_help_person_family_relation'
  },
  {
    title: '身份证号',
    dataIndex: 'need_help_person_family_number_id',
    key: 'need_help_person_family_number_id'
    // width: '300px'
  },
  {
    title: '年收入',
    dataIndex: 'need_help_person_family_income',
    key: 'need_help_person_family_income'
    // width: '300px'
  },
  {
    title: '年龄',
    dataIndex: 'need_help_person_family_gender',
    key: 'need_help_person_family_gender'
  },
  {
    title: '单位（学校）名称',
    dataIndex: 'need_help_person_family_school',
    key: 'need_help_person_family_school'
  },
  {
    title: '操作',
    key: 'action',
    width: '80px',
    scopedSlots: { customRender: 'action' }
  }
]

const column = [
  {
    title: '成员姓名',
    dataIndex: 'need_help_person_family_name',
    key: 'need_help_person_family_name'
  },
  {
    title: '与户主关系',
    dataIndex: 'need_help_person_family_relation',
    key: 'need_help_person_family_relation'
  },
  {
    title: '身份证号',
    dataIndex: 'need_help_person_family_number_id',
    key: 'need_help_person_family_number_id'
    // width: '300px'
  },
  {
    title: '年龄',
    dataIndex: 'need_help_person_family_gender',
    key: 'need_help_person_family_gender'
  },
  {
    title: '单位（学校）名称',
    dataIndex: 'need_help_person_family_school',
    key: 'need_help_person_family_school'
  },
  {
    title: '年收入',
    dataIndex: 'need_help_person_family_income',
    key: 'need_help_person_family_income'
    // width: '300px'
  }
]

const itemColumns = [
  {
    title: '项目编号',
    dataIndex: 'num',
    key: 'num',
    scopedSlots: { customRender: 'num' }
  },
  {
    title: '项目名称',
    dataIndex: 'process_base_title',
    key: 'process_base_title'
  },
  {
    title: '项目状态',
    dataIndex: 'process_status',
    key: 'process_status'
  },
  {
    title: '操作',
    key: 'action',
    width: '80px',
    scopedSlots: { customRender: 'action' }
  }
]

const logColumns = [
  {
    title: '时间',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '活动名称',
    dataIndex: 'process_base_title',
    key: 'process_base_title'
  },
  {
    title: '活动类型',
    dataIndex: 'process_type',
    key: 'process_type'
  },
  {
    title: '活动状态',
    dataIndex: 'process_status',
    key: 'process_status'
  },
  {
    title: '操作',
    key: 'action',
    width: '80px',
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  name: 'Index',
  components: {
    Form
  },
  props: {
    initData: {
      // 父组件传过来的表单默认值
      type: Object,
      default: () => {
        return {}
      }
    },
    checkDisabled: {
      type: Function,
      default: () => { }
    },
    checkDisplay: {
      type: Function,
      default: () => { }
    },
    pageType: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      columns,
      column,
      itemColumns,
      logColumns,
      peopleInfo: {}, // 家庭成员表单数据
      peopleList: this._.cloneDeep(this.initData.need_help_person_family_list) || [], // 家庭成员
      visible: false, // 新增家庭成员弹出框
      edit: false, // 标记是编辑还是新增
      editId: ''
    }
  },
  computed: {
    params() {
      // props数据
      return {
        checkDisabled: this.checkDisabled || (() => { }),
        checkDisplay: this.checkDisplay || (() => { }),
        numberChange: this.numberChange || (() => { }),
        numberChangeFamily: this.numberChangeFamily || (() => { })
      }
    },
    getBaseForm() {
      // 获取formData
      return forms.getBaseForm(this._.cloneDeep(this.initData), this.params, this.pageType)
    },
    getFamilyForm() {
      // 新增界面form
      return forms.getPeopleForm(this)
    }
  },
  watch: {
    initData(value) {
      if (value) {
        this.peopleList = this._.cloneDeep(value.need_help_person_family_list) || []
        this.getPeopleList(this.peopleList)
      }
    }
  },
  mounted() {
    this.getPeopleList(this.peopleList) // 处理家庭成员数据
  },
  methods: {
    getValue(params) {
      // 获取数据
      const data = this.$refs.familyForm.getFieldsValue(params)
      data.need_help_person_family_list = this.setPeopleList()
      return data
    },
    onSubmit(params) {
      // 校验并获取数据
      const data = this.$refs.familyForm.handleSubmit(params)
      data.need_help_person_family_list = this.setPeopleList()
      return data
    },
    idCardChange(data) {
      const idCardData = getAgeAndSexByIDNum(data)
      if (!idCardData) return
      this.$refs.familyPeople.setFieldsValue('need_help_person_family_gender', idCardData.age)
    },
    // 将每条数据里的ID去掉
    setPeopleList() {
      const people = this.peopleList
      for (let i = 0; i < people.length; i++) {
        delete people[i].id
      }
      return people
    },
    // 给每条数据一个唯一ID
    getPeopleList(people) {
      for (let i = 0; i < people.length; i++) {
        people[i].id = i
      }
      this.peopleList = people
      // console.log(this.peopleList)
    },
    numberChange(value, id) {
      // 只能输入数字校验
      let newValue = value
      newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      newValue = newValue
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.familyForm.setFieldsValue(id, newValue)
      }, 0)
    },
    numberChangeFamily(value, id) {
      // 只能输入数字校验
      // let newValue = value
      // newValue = newValue.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
      // newValue = newValue.replace(/^\./g, '') // 验证第一个字符是数字而不是.
      // newValue = newValue.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的.
      // newValue = newValue
      //   .replace('.', '$#$')
      //   .replace(/\./g, '')
      //   .replace('$#$', '.')
      setTimeout(() => {
        this.$refs.familyPeople.setFieldsValue(id, value)
      }, 0)
    },
    // 校验身份证号是否合法
    checkIdCard(rule, value, callback) {
      if (value && !checkIdCard(value)) {
        const title = '请输入正确的身份证号'
        callback(title)
      } else {
        callback()
      }
    },
    // 新增家庭成员
    increasePeople() {
      this.visible = true
      // this.edit = false
      // this.peopleInfo = {}
      // this.$refs.familyPeople.resetFields()
    },
    // 确定添加家庭成员
    handleOk() {
      const peopleInfo = this.$refs.familyPeople.handleSubmit()
      // const people = this.peopleList
      if (peopleInfo) {
        //   if (this.edit) {
        //     for (let i = 0; i < people.length; i++) {
        //       if (people[i].id === this.editId) {
        //         people[i] = Object.assign({}, people[i], peopleInfo)
        //         break
        //       }
        //     }
        //     this.peopleList = people
        //   } else {
        this.peopleList.push(peopleInfo)
        this.getPeopleList(this.peopleList)
        this.$refs.familyPeople.resetFields()
        this.visible = false
      }

      // }
    },
    // 编辑家庭成员信息
    editPeople(data) {
      this.visible = true
      this.edit = true
      this.editId = data.id
      this.peopleInfo = data
    },
    // show (record) {
    //   const params = {
    //     process_base_work_number: record.process_base_work_number,
    //     process_base_status: record.process_base_status
    //   }
    //   if (record.process_config_type && record.process_config_type === 'releaseOfFunds') { // 判断是什么流程，就跳到什么页面，资金帮扶流程
    //     this.$router.push({
    //       path: '/assit/compositeAssit/increaseItem',
    //       query: { pageType: 'view', processData: JSON.stringify(params) }
    //     })
    //   } else if (record.process_config_type && record.process_config_type === 'activityConfirmation') { // 活动帮扶
    //     this.$router.push({
    //       path: '/assit/compositeAssit/activeAssit',
    //       query: { pageType: 'view', processData: JSON.stringify(params) }
    //     })
    //   } else if (record.process_config_type && record.process_config_type === 'individualCase') { // 个案帮扶
    //     this.$router.push({
    //       path: '/assit/compositeAssit/increaseAssitPeople',
    //       query: { pageType: 'view', processData: JSON.stringify(params) }
    //     })
    //     window.location.reload()
    //     // setTimeout(function () { window.location.reload()() }, 0)
    //   } else if (record.process_config_type && record.process_config_type === 'ghReleaseOfFunds') { // 资金帮扶-帮侬一把
    //       this.$router.push({
    //         path: '/assit/compositeAssit/fundAssit',
    //         query: { pageType: 'view', processData: JSON.stringify(params) }
    //       })
    //     } else if (record.process_config_type && record.process_config_type === 'ghActivityConfirmation') { // 活动帮扶-帮侬一把
    //       this.$router.push({
    //         path: '/assit/compositeAssit/givemeActive',
    //         query: { pageType: 'view', processData: JSON.stringify(params) }
    //       })
    //     } else if (record.process_config_type && record.process_config_type === 'internalDocuments') { // 文件
    //       this.$router.push({
    //       path: '/assit/contentManagement/increaseFile',
    //       query: { pageType: 'view', processData: JSON.stringify(params) }
    //     })
    //   }
    // },
    // 删除家庭成员
    deletePeople(data) {
      for (let i = 0; i < this.peopleList.length; i++) {
        if (data.id === this.peopleList[i].id) {
          this.peopleList.splice(i, 1)
          break
        }
      }
      this.getPeopleList(this.peopleList)
    },
    // 弹出框关闭
    cancel() {
      // this.peopleInfo = {}
      this.$refs.familyPeople.resetFields()
      this.visible = false
    }
  }
}
</script>

<style scoped lang="less">
@import "../../../style.less";
.formDom {
  /deep/ .ant-alert {
    padding: 5px 5px 5px 35px;
    font-size: 12px;
    .ant-alert-icon {
      top: 8px;
    }
  }
  .show {
    color: #3d73dd;
    cursor: pointer;
  }
  .show:hover {
    color: #4d86ff;
  }
  .personList {
    position: relative;
    border: 1px solid #e8e8e8;
    /deep/ .ant-table-wrapper {
      border-radius: 2px;
    }
    /deep/ .ant-table-placeholder {
      border-bottom: none;
    }
  }
}
</style>
